<template>
    <div class="container space-y-10 xl:py-20 py-10">
        <div class="text-center space-y-2">
            <h2 class="text-gray-100 xl:text-title-xl text-title-lg font-bold">{{ content.title }}</h2>
            <p class="text-gray-500 xl:text-body-lg text-body-md">{{ content.subtitle }}</p>
        </div>

        <div class="flex gap-6 overflow-x-auto lg:overflow-x-hidden">
            <template v-for="cardItem in content.items">
                <NuxtLinkLocale :to="cardItem.link" class="xl:w-full min-w-[267px]">
                    <div class="p-4 h-[367px] rounded-2xl relative">
                        <NuxtImg
                            class="h-full opacity-60 rounded-2xl object-cover"
                            :src="cardItem.image.src"
                            :alt="cardItem.image.alt"
                            loading="lazy"
                        />
                        <p
                            class="absolute top-1/2 left-1/2 text-center font-bold text-gray-100 -translate-x-1/2 -translate-y-1/2"
                        >
                            {{ cardItem.text }}
                        </p>
                    </div>
                </NuxtLinkLocale>
            </template>
        </div>

        <div>
            <NuxtLinkLocale :to="content.cta?.link">
                <AppButton :id="id" class="mx-auto" variant="outlined" color="brand">{{ content.cta?.text }}</AppButton>
            </NuxtLinkLocale>
        </div>
    </div>
</template>

<script lang="ts">
// * cause of unknown vue error about hoisted default variables i created another script to declare default values with *multilingual* feature
// * also cause of i18n error i exported a default function that returns the mock and default data
export const defaultContent = () => {
    const { t } = useI18n();

    return {
        title: t("landingComponents_ideationCenter_title"),
        subtitle: t("landingComponents_ideationCenter_desc"),
        cta: {
            text: t("landingComponents_ideationCenter_button"),
            link: "/ideas",
        },
        items: [
            {
                text: t("landingComponents_ideationCenter_item_1"),
                link: "/ideas/modern-master-bedroom-furniture",
                image: {
                    src: "https://s3.amazonaws.com/ideas-after/984c6348-65c5-423c-9539-7b4f082763c5.jpeg",
                    alt: "modern master bedroom",
                },
            },
            {
                text: t("landingComponents_ideationCenter_item_2"),
                link: "/ideas/scandinavian-white-kitchen",
                image: {
                    src: "https://s3.amazonaws.com:443/ideas-after/85217df3-9ee8-4f1c-9042-5b8e9073d93d.jpeg",
                    alt: "scandinavian kitchen",
                },
            },
            {
                text: t("landingComponents_ideationCenter_item_3"),
                link: "/ideas/white-farmhouse-bedroom",
                image: {
                    src: "https://s3.amazonaws.com:443/ideas-after/8bc02097-a0c2-49fd-81b6-6f3af18486ee.jpeg",
                    alt: "white farmhouse",
                },
            },
            {
                text: t("landingComponents_ideationCenter_item_4"),
                link: "/ideas/blue-and-orange-living-room",
                image: {
                    src: "https://s3.amazonaws.com:443/ideas-after/65c4112b-f6aa-4d7e-8220-5f28ae1474b3.jpeg",
                    alt: "living room",
                },
            },
        ],
    };
};
</script>

<script setup lang="ts">
interface IProps {
    id?: string;
    content: IIdeationCenter;
}

const props = withDefaults(defineProps<IProps>(), {
    content: () => {
        return defaultContent();
    },
});
</script>
